import { render } from "./CryptoScreenshot.vue?vue&type=template&id=cd458dd4"
import script from "./CryptoScreenshot.vue?vue&type=script&lang=js"
export * from "./CryptoScreenshot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__